import { useMemo } from "react"

import { DEFAULT_PERIOD } from "./TrendCard"
import type { TrendColumnData } from "./TrendColumn"

interface TrendPeriodData {
  last_period: number
  prev_period: number
  date_data: { date: string; count: number }[]
}

interface ComputedTrend extends Pick<TrendColumnData, "value" | "trend" | "chart"> {
  lastPeriodCount: number
  prevPeriodCount: number
}

export function computeTrend(data: TrendPeriodData | undefined, period: number): ComputedTrend {
  if (!data) {
    return {
      value: 0,
      lastPeriodCount: 0,
      prevPeriodCount: 0,
      trend: { direction: "flat", days: `past ${period} days` },
      chart: undefined,
    }
  }

  const { last_period, prev_period, date_data } = data
  const diff = last_period - prev_period
  const direction: "up" | "down" | "flat" = diff > 0 ? "up" : diff < 0 ? "down" : "flat"
  const percent = prev_period !== 0 ? Math.round(Math.abs(diff / prev_period) * 100) : last_period !== 0 ? 100 : 0
  const color = direction === "down" ? "#EF4444" : direction === "up" ? "#22C55E" : "#94a3b8"

  return {
    value: last_period,
    lastPeriodCount: last_period,
    prevPeriodCount: prev_period,
    trend: {
      direction,
      ...(direction !== "flat" && { percent: `${percent}%` }),
      days: `past ${period} days`,
    },
    chart: date_data.length > 0 ? { data: date_data.map(d => d.count), color } : undefined,
  }
}

export function usePeriodDays(period: number | undefined): number {
  return useMemo(() => period ?? DEFAULT_PERIOD, [period])
}
